function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}

;
Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);

/* icon/UI 24px/File Type JPG (jpeg).svg: width 24px x height 24px */
var DlsIconFileTypeJpg =
/*#__PURE__*/
function (_CustomElement2) {
  _inherits(DlsIconFileTypeJpg, _CustomElement2);

  function DlsIconFileTypeJpg() {
    _classCallCheck(this, DlsIconFileTypeJpg);

    return _possibleConstructorReturn(this, _getPrototypeOf(DlsIconFileTypeJpg).apply(this, arguments));
  }

  _createClass(DlsIconFileTypeJpg, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" display=\"block\" pointer-events=\"none\" viewBox=\"0 0 24 24\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M21.553 11.41h-3.22v1h2.14v.19c0 .547-.175.978-.525 1.295-.35.317-.818.475-1.405.475-.693 0-1.243-.237-1.65-.71-.406-.473-.61-1.127-.61-1.96 0-.547.095-1.022.285-1.425.19-.403.46-.712.81-.925.35-.213.752-.32 1.205-.32.414 0 .785.08 1.115.24.33.16.702.437 1.115.83l.75-.77c-.46-.473-.92-.813-1.38-1.02-.46-.207-.99-.31-1.59-.31-.72 0-1.345.158-1.875.475-.53.317-.936.755-1.22 1.315-.283.56-.425 1.193-.425 1.9 0 .727.134 1.37.4 1.93.267.56.655.997 1.165 1.31.51.313 1.119.47 1.825.47.98 0 1.684-.307 2.11-.92l.07.77h.91v-3.84zM5.945 14.895c.357-.33.535-.835.535-1.515V8.15H5.3v5.11c0 .373-.08.647-.24.82-.16.173-.383.26-.67.26-.233 0-.457-.028-.67-.085A6.934 6.934 0 012.97 14l-.37.94c.273.133.572.242.895.325.323.083.638.125.945.125.647 0 1.148-.165 1.505-.495zm7.382-6.155c-.42-.393-.984-.59-1.69-.59h-3.26v7.1h1.19v-2.73h2.07c.706 0 1.27-.195 1.69-.585.42-.39.63-.922.63-1.595 0-.673-.21-1.207-.63-1.6zm-3.76.39v2.41h1.87c.42 0 .75-.103.99-.31.24-.207.36-.503.36-.89s-.12-.685-.36-.895c-.24-.21-.57-.315-.99-.315h-1.87z\" clip-rule=\"evenodd\"/></svg>";
    }
  }], [{
    key: "define",
    value: function define() {
      var tagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'dls-icon-file-type-jpg';

      try {
        window.customElements.define(tagName, this);
      } catch (e) {
        /* console.error(e); */
      }
    }
  }]);

  return DlsIconFileTypeJpg;
}(_CustomElement);

export { DlsIconFileTypeJpg as default };
DlsIconFileTypeJpg.define();